import { BulletinsService } from 'src/services/bulletins.service';
import React from 'react';
import Spinner from '../../ui/spinner';
import { useLocalization } from 'src/utils/useLocalization';
import { useTranslation } from 'react-i18next';

import { formatDate } from 'src/utils/helpers';
import './bulletinList.scss';

const CURRENT_ENGLISH_LANGUAGE_CODE = 1;
const CURRENT_FRENCH_LANGUAGE_CODE = 2;
const LEGACY_ENGLISH_LANGUAGE_CODE = 0;
const LEGACY_FRENCH_LANGUAGE_CODE = 1;
const ENGLISH_LANGUAGE_CODES = [
    CURRENT_ENGLISH_LANGUAGE_CODE,
    LEGACY_ENGLISH_LANGUAGE_CODE,
];
const FRENCH_LANGUAGE_CODES = [
    CURRENT_FRENCH_LANGUAGE_CODE,
    LEGACY_FRENCH_LANGUAGE_CODE,
];

export interface BulletinItem {
    title: string;
    createdTime: string;
    validFrom: string;
    validThrough: string;
    documentId: string;
    bulletinLanguage: number;
    bulletinNumber: string | number;
    bulletinType: number;
}

const BulletinList: React.FC<{
    bulletinsDataset?: Array<BulletinItem>;
}> = ({ bulletinsDataset }) => {
    const { bulletins, data } = useLocalization();
    const { i18n } = useTranslation();

    const currentLanguage = i18n.language;
    const loader = (
        <div className='loader_container'>
            <Spinner />
        </div>
    );

    async function handlePdf(id: string) {
        try {
            const service = new BulletinsService();
            const res = await service.getBulletin(id);
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
            URL.revokeObjectURL(url);
        } catch (error) {
            console.log('Error descargando PDF:', error);
        }
    }

    const languageCodes = currentLanguage.includes('en')
        ? ENGLISH_LANGUAGE_CODES
        : FRENCH_LANGUAGE_CODES;

    return (
        <div className='bullet-item-container'>
            {bulletinsDataset ? (
                <div>
                    {bulletinsDataset.length ? (
                        <>
                            <div className='bullet-item title'>
                                <div className='u-text-truncate'>
                                    {bulletins.LABEL_BULLETINS_NAME}
                                </div>
                                <div className='u-text-truncate'>
                                    {bulletins.LABEL_BULLETINS_POSTED}
                                </div>
                                <div className='bullet-effective-dates u-text-truncate'>
                                    {bulletins.LABEL_BULLETINS_EFFECTIVE_DATES}
                                </div>
                            </div>
                            <div className='bullet-list-container'>
                                {bulletinsDataset.map((bullet, index) =>
                                    languageCodes.includes(
                                        bullet.bulletinLanguage,
                                    ) ? (
                                        <div
                                            key={index}
                                            className='bullet-item'
                                        >
                                            <div className='mobile-strong'>
                                                <a
                                                    href='#'
                                                    onClick={() => {
                                                        handlePdf(
                                                            bullet.documentId,
                                                        );
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {bullet.title}
                                                </a>
                                            </div>
                                            <div className='mobile-grid'>
                                                <span className='mobile-strong mobile-shown'>
                                                    {
                                                        bulletins.LABEL_BULLETINS_POSTED
                                                    }
                                                </span>
                                                <span>
                                                    {formatDate(
                                                        bullet.createdTime,
                                                    )}
                                                </span>
                                            </div>
                                            <div className='bullet-effective-dates mobile-grid'>
                                                <span className='mobile-strong mobile-shown'>
                                                    {
                                                        bulletins.LABEL_BULLETINS_EFFECTIVE_DATES
                                                    }
                                                </span>
                                                <span>{`${formatDate(
                                                    bullet.validFrom,
                                                )} - ${formatDate(
                                                    bullet.validThrough,
                                                )}`}</span>
                                            </div>
                                        </div>
                                    ) : null,
                                )}
                            </div>
                        </>
                    ) : (
                        <div className={'no-data'}>
                            {data.NO_DATA_AVAILABLE}
                        </div>
                    )}
                </div>
            ) : (
                loader
            )}
        </div>
    );
};

export default BulletinList;
